<ion-header>
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-back-button text="" (click)="close()"></ion-back-button>
    </ion-buttons>
    <ion-title>
      Server updaten
    </ion-title>
  </ion-toolbar>
</ion-header>

<ion-content class="ion-padding">
  <div class="step" *ngFor="let step of steps">
    <div class="number">
      {{step}}.
    </div>
    <img src="/assets/Images/server_update_guide/step{{step}}.png" alt="">
  </div>
</ion-content>
